var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "px-4" },
      [
        _c(
          "div",
          {
            staticClass:
              "shadow bg-white px-4 py-12 rounded-lg relative overflow-hidden print-padding",
          },
          [
            _c("div", { staticClass: "max-w-5xl m-auto mb-10 font-outfit" }, [
              _c(
                "div",
                { staticClass: "max-w-3xl m-auto" },
                [
                  _c("InvoiceHeader", {
                    attrs: { message: "View invoice" },
                    on: { back: _vm.handleBack, close: _vm.handleClose },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "invoice-detail-wrapper",
                  attrs: { id: "receipt" },
                },
                [
                  _c("div", { staticClass: "invoice-header" }, [
                    _c("div", { staticClass: "invoice-header-wrap" }, [
                      _c("h2", [
                        _vm._v(
                          " Invoice #" +
                            _vm._s(_vm.invoiceInfo["Reference Number"]) +
                            " "
                        ),
                      ]),
                      _c("ul", { staticClass: "list-btns hidden-print" }, [
                        _c(
                          "li",
                          [
                            _c("UiButton", {
                              attrs: {
                                buttonText: "Copy Link",
                                buttonClasses:
                                  "px-2 pr-3.5 pl-3.5 customHeight invoice-table-buttons",
                                variant: "white",
                              },
                              on: { click: _vm.handleCopy },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c("UiButton", {
                              attrs: {
                                buttonText: "Download",
                                buttonClasses:
                                  "px-2 pr-3.5 pl-3.5 customHeight invoice-table-buttons",
                                variant: "white",
                              },
                              on: { click: _vm.handleDownload },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c("UiButton", {
                              attrs: {
                                buttonText: "Share via Email",
                                buttonClasses:
                                  "px-2 pr-3.5 pl-3.5 customHeight invoice-table-buttons",
                                variant: "white",
                              },
                              on: { click: _vm.sendInvoiceByEmail },
                            }),
                          ],
                          1
                        ),
                        _vm.status(_vm.invoiceInfo["Status"]) ===
                          "Pending Approval" ||
                        _vm.status(_vm.invoiceInfo["Status"]) ===
                          "Invoice Rejected"
                          ? _c(
                              "li",
                              [
                                _c("UiButton", {
                                  attrs: {
                                    buttonText: "Edit Invoice",
                                    buttonClasses:
                                      "px-2 pr-3.5 pl-3.5 customHeight invoice-table-buttons",
                                    variant: "white",
                                  },
                                  on: { click: _vm.handleEdit },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.status(_vm.invoiceInfo["Status"]) ===
                          "Pending Approval" && _vm.currentUser.role !== "ADMIN"
                          ? _c(
                              "li",
                              [
                                _c("UiButton", {
                                  attrs: {
                                    buttonText: "Cancel Invoice",
                                    buttonClasses:
                                      "px-2 pr-3.5 pl-3.5 customHeight invoice-table-buttons",
                                    variant: "white",
                                  },
                                  on: { click: _vm.toggle },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _c("div", { staticClass: "invoice-details" }, [
                      _c("div", { staticClass: "invoice-details-col" }, [
                        _c("strong", { staticClass: "title" }, [
                          _vm._v("Bill To"),
                        ]),
                        _c("p", [
                          _vm._v(_vm._s(_vm.invoiceInfo["Company Name"])),
                        ]),
                      ]),
                      _c("div", { staticClass: "invoice-details-col" }, [
                        _c("strong", { staticClass: "title" }, [
                          _vm._v("Resource"),
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.invoiceInfo["User Name"]))]),
                      ]),
                      _c("div", { staticClass: "invoice-details-col" }, [
                        _c("strong", { staticClass: "title" }, [
                          _vm._v("Date of Submission"),
                        ]),
                        _c("p", [
                          _vm._v(_vm._s(_vm.invoiceInfo["Submission Date"])),
                        ]),
                      ]),
                      _c("div", { staticClass: "invoice-details-col" }, [
                        _c("strong", { staticClass: "title" }, [
                          _vm._v("Status"),
                        ]),
                        _c("p", [
                          _c(
                            "span",
                            {
                              staticClass: "pills-badge",
                              class: _vm.invoiceInfo["Status"],
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.status(_vm.invoiceInfo["Status"]))
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "invoice-border-section" }, [
                    _c("h3", [_vm._v("Invoice Details")]),
                    _c("ul", { staticClass: "invoice-details-list" }, [
                      _c("li", [
                        _c("strong", { staticClass: "title" }, [
                          _vm._v("Client"),
                        ]),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(" " + _vm._s(_vm.invoiceInfo.Project) + " "),
                        ]),
                      ]),
                      _c("li", [
                        _c("strong", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.invoiceInfo["fileTypeMessage"])),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "description w-full overflow-hidden link-hid",
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.invoiceInfo[
                                    "External Invoice Link"
                                  ],
                                },
                              },
                              [_vm._v(_vm._s(_vm.invoiceInfo["fileName"]))]
                            ),
                          ]
                        ),
                      ]),
                      _c("li", [
                        _c("strong", { staticClass: "title" }, [
                          _vm._v("Total hours"),
                        ]),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            " " + _vm._s(_vm.invoiceInfo["Total hours"]) + " "
                          ),
                        ]),
                      ]),
                      _c("li", [
                        _c("strong", { staticClass: "title" }, [
                          _vm._v("Total Amount before taxes"),
                        ]),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.invoiceInfo["Total Amount before taxes"]
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "invoice-border-section" }, [
                    _c("h3", [_vm._v("Total Hours")]),
                    _c("table", { staticClass: "table-hours" }, [
                      _vm._m(0),
                      _c(
                        "tbody",
                        _vm._l(_vm.invoiceData, function (item) {
                          return _c("tr", { key: item.id }, [
                            _c("td", [_vm._v(_vm._s(item.date))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(item.rate !== null ? item.rate : "n/a")
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(item.hours))]),
                            _c("td", [_vm._v(_vm._s(item.totalAmount))]),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
            _vm.currentUser.role === "ADMIN" &&
            _vm.invoiceInfo["Status"] === "PENDING"
              ? _c(
                  "div",
                  { staticClass: "invoice-action-buttons hidden-print" },
                  [
                    _c("UiButton", {
                      attrs: {
                        buttonText: "Reject Selected",
                        buttonClasses:
                          "px-2 pr-3.5 pl-3.5 customHeight40 invoice-view-buttons button-danger",
                        variant: "danger",
                      },
                      on: { click: _vm.approveSelected },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "icon",
                            fn: function () {
                              return [_c("Cross", { staticClass: "mt-1" })]
                            },
                            proxy: true,
                          },
                          {
                            key: "hover-icon",
                            fn: function () {
                              return [_c("Cross", { staticClass: "mt-1" })]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        208082658
                      ),
                    }),
                    _c("UiButton", {
                      attrs: {
                        buttonText: "Approve Invoice",
                        buttonClasses:
                          "px-2 pr-3.5 pl-3.5 customHeight40 invoice-view-buttons",
                        variant: "black",
                      },
                      on: { click: _vm.approveSelected },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "icon",
                            fn: function () {
                              return [_c("TickIcon")]
                            },
                            proxy: true,
                          },
                          {
                            key: "hover-icon",
                            fn: function () {
                              return [_c("TickIcon")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2612234434
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
        _c("CancelInvoiceModal", {
          on: { cancelInvoice: _vm.cancelSelected },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Visit")]),
        _c("th", [_vm._v("Rate")]),
        _c("th", [_vm._v("Hours")]),
        _c("th", [_vm._v("Total amount")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }